import { render, staticRenderFns } from "./policyDocument.vue?vue&type=template&id=aaf1f10a&scoped=true&"
import script from "./policyDocument.vue?vue&type=script&lang=js&"
export * from "./policyDocument.vue?vue&type=script&lang=js&"
import style0 from "./policyDocument.vue?vue&type=style&index=0&id=aaf1f10a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aaf1f10a",
  null
  
)

export default component.exports